var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeatmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 52,
    viewBox: "0 0 65 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0878906,
    width: 64,
    height: 52,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.33789,
    y: 5.25,
    width: 19.1875,
    height: 7.89981,
    fill: "#5296FC",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.33789,
    y: 13.6484,
    width: 19.1875,
    height: 7.89981,
    fill: "#86B5FD",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.33789,
    y: 22.0498,
    width: 19.1875,
    height: 7.89981,
    fill: "#86B5FD",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.33789,
    y: 30.4492,
    width: 19.1875,
    height: 7.89981,
    fill: "#4C7BDB",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.33789,
    y: 38.8506,
    width: 19.1875,
    height: 7.89981,
    fill: "#86B5FD",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0254,
    y: 5.25,
    width: 20.125,
    height: 7.89981,
    fill: "#4C7BDB",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0254,
    y: 22.0498,
    width: 20.125,
    height: 7.89981,
    fill: "#4C7BDB",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0254,
    y: 13.6484,
    width: 20.125,
    height: 7.89981,
    fill: "#86B5FD",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0254,
    y: 30.4492,
    width: 20.125,
    height: 7.89981,
    fill: "#86B5FD",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0254,
    y: 38.8506,
    width: 20.125,
    height: 7.89981,
    fill: "#86B5FD",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6504,
    y: 22.0498,
    width: 19.1875,
    height: 7.89981,
    fill: "#86B5FD",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6504,
    y: 5.25,
    width: 19.1875,
    height: 7.89981,
    fill: "#4C7BDB",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6504,
    y: 13.6484,
    width: 19.1875,
    height: 7.89981,
    fill: "#5296FC",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6504,
    y: 30.4492,
    width: 19.1875,
    height: 7.89981,
    fill: "#4C7BDB",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6504,
    y: 38.8506,
    width: 19.1875,
    height: 7.89981,
    fill: "#4C7BDB",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmap);
export default __webpack_public_path__ + "static/media/heatmap.a6c54701a96c29a1ce85542114e107c0.svg";
export { ForwardRef as ReactComponent };